<template>
  <a @click="goToTransactionDetails"
     class="list-group-item-action list-group-item list-group-item-with-icon wallet-transaction"
     :id="`transaction-${transaction.transactionId}`"
     href="javascript:void(0)">
    <div>
      <strong class="transaction-description">{{ transaction.description }}</strong>
      <div class="small text-muted transaction-date">{{ formattedDate(transaction.date) }}</div>
    </div>
    <TransactionAmount :amount="transaction.amount" :currency="transaction.currency"/>
  </a>
</template>

<script>

import TransactionAmount from '@shared/components/wallet/TransactionAmount'
import TransactionDateMixin from '@shared/mixins/TransactionDateMixin'

export default {
  props: ['transaction'],
  components: {
    TransactionAmount
  },
  mixins: [TransactionDateMixin],
  methods: {
    goToTransactionDetails() {
      this.$router.push({ name: 'transaction-details', params: { id: this.transaction.transactionId } })
    }
  }
}
</script>
